import { useMemo } from 'react';
import { useContentProgress, type useContentProgressResponse } from 'ContentProgress';
import { type StreamForStreamDashboard } from 'Lessons';

type ProgressMaps = Pick<useContentProgressResponse, 'streamProgressByLocalePackId' | 'lessonProgressByLocalePackId'>;

/*
    Replaces the payload progress with ContentProgress (IndexedDB). RTK Query serves a cached payload on
    return visits, so payload progress goes stale after a lesson. Signed-in students only.
*/
function withLiveProgress(
    stream: StreamForStreamDashboard,
    { streamProgressByLocalePackId, lessonProgressByLocalePackId }: ProgressMaps,
): StreamForStreamDashboard {
    return {
        ...stream,
        lessonStreamsProgress: streamProgressByLocalePackId[stream.localePackId] ?? null,
        lessons: stream.lessons.map(lesson => ({
            ...lesson,
            lessonProgress: lessonProgressByLocalePackId[lesson.localePackId] ?? null,
        })),
    };
}

export function useStreamWithLiveProgress(stream: StreamForStreamDashboard | null) {
    const contentProgress = useContentProgress();

    return useMemo(() => (stream ? withLiveProgress(stream, contentProgress) : null), [stream, contentProgress]);
}
